import React, { Component } from "react";
import { TTP_API_URL, SOCIAL_NETWORKS_HOSTS } from "Config";

import styles from "./Profile.local.scss";
import classnames from "classnames";

import { getUserNameForAvatar, addLandaSize } from "Utils";

import _ from "i18n";

export default class ProfileComponent extends Component {
  renderSN(socialNetworkName) {
    const { contactSocialNetworks } = this.props.user;

    let socialNetwork = contactSocialNetworks[socialNetworkName];

    if (socialNetwork) {
      let accessValue =
        socialNetworkName === "twitter"
          ? socialNetwork.username
          : socialNetwork.id;
      let url =
        socialNetworkName === "linkedin"
          ? socialNetwork.publicProfileUrl
            ? socialNetwork.publicProfileUrl
            : ""
          : `${
              SOCIAL_NETWORKS_HOSTS[socialNetworkName.toUpperCase()]
            }/${accessValue}`;

      return (
        <li>
          <a href={`${url}`} target="_blank">
            <img
              src={`/img/social/${socialNetworkName}.svg`}
              alt={socialNetworkName}
              className={styles[socialNetworkName]}
            />
          </a>
        </li>
      );
    }

    return null;
  }

  renderAvatar() {
    const { avatar, avatarUrl, firstName, lastName } = this.props.user;

    if (avatar || avatarUrl) {
      return (
        <div
          className={styles.avatar}
          style={{
            backgroundImage: `url(${
              avatarUrl
                ? addLandaSize(avatarUrl, 300)
                : TTP_API_URL + "/" + avatar
            })`
          }}
        />
      );
    }
    return (
      <div className={styles.avatar}>
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
      </div>
    );
  }

  renderCompany(company) {
    if (!company) {
      return null;
    }
    const { name, abbreviation, avatar, avatarUrl } = company;

    let helpAvatar = "/img/logo.svg";

    if (avatar || avatarUrl) {
      helpAvatar = avatarUrl
        ? addLandaSize(avatarUrl, 240)
        : TTP_API_URL + "/" + avatar;
    }
    return (
      <div className={classnames(styles.organization, "cell small-3")}>
        <span>{_("Company")}</span>
        <div
          className={styles.logo}
          style={{
            backgroundImage: `url(${helpAvatar})`
          }}
        />
        <h3>{abbreviation || name}</h3>
      </div>
    );
  }

  renderUserInfos() {
    const { nbResult, user } = this.props;
    const { firstName, lastName, description, contactSocialNetworks } = user;

    let totalResult = 0;

    if (nbResult) {
      const { medias, favorites, albums } = nbResult;

      if (medias) {
        totalResult += parseInt(medias, 10);
      }
      if (favorites) {
        totalResult += parseInt(favorites, 10);
      }
      if (albums) {
        totalResult += parseInt(albums, 10);
      }
    }
    return (
      <div className={classnames(styles.user, "cell small-6")}>
        <h1>{`${firstName}${lastName ? ` ${lastName}` : ""}`}</h1>
        {description ? <p>{description}</p> : null}
        {contactSocialNetworks ? (
          <ul>
            {this.renderSN("facebook")}
            {this.renderSN("twitter")}
            {this.renderSN("linkedin")}
          </ul>
        ) : null}
        <span className={styles.sumMedias}>{_("Total media")}</span>
        <strong>{totalResult === 0 ? "" : totalResult}</strong>
      </div>
    );
  }

  renderCover() {
    const { cover, coverUrl } = this.props.user;

    let helpCover = "/img/cover.svg";

    if (cover || coverUrl) {
      helpCover = coverUrl || TTP_API_URL + "/" + cover;
    }
    return (
      <div
        className={styles.cover}
        style={{ backgroundImage: `url(${helpCover})` }}
      />
    );
  }

  render() {
    const { navCommunity, onChangeTab, nbResult } = this.props;

    return (
      <div className={styles.profile}>
        {this.renderCover()}
        {this.renderAvatar()}
        <div className={styles.body}>
          <div className={classnames(styles.infos, "grid-x")}>
            {this.renderCompany(navCommunity)}
            {this.renderUserInfos()}
            {this.renderCompany(navCommunity)}
          </div>
          <ul className={styles.tabs}>
            <li
              className={classnames(styles.tab, styles.activated)}
              onClick={onChangeTab.bind(this, "MEDIA")}
            >
              {_("My medias")}
              <span>{nbResult.medias ? nbResult.medias : ""}</span>
            </li>
            <li
              className={styles.tab}
              onClick={onChangeTab.bind(this, "FAVORITE")}
            >
              {_("My favorites")}
              <span>{nbResult.favorites ? nbResult.favorites : ""}</span>
            </li>
            <li
              className={styles.tab}
              onClick={onChangeTab.bind(this, "ALBUM")}
            >
              {_("My albums")}
              <span>{nbResult.albums ? nbResult.albums : ""}</span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MyMedias/Profile/ProfileComponent.js